import React from 'react'
import PropTypes from 'prop-types'
import ThemeContext from './contexts/ThemeContext'
import { observable } from 'mobx'
import { Enum } from '@morningtrain/helpers'
import { useEventListeners } from '@morningtrain/react-helpers'

export default function Theme (props) {
  const themes = props.themes || Object.keys((new Enum(props.enum)).raw)
  const defaultTheme = props.defaultTheme
    ? props.defaultTheme
    : themes[0]

  const themeBox = observable.box(defaultTheme)

  const [triggerOnBeforeThemeChange, onBeforeThemeChange] = useEventListeners()

  const theme = {
    set: (value) => {
      Promise.resolve(triggerOnBeforeThemeChange())
        .then(() => {
          themeBox.set(value)
        })
    },
    get: () => {
      return themeBox.get()
    },
    triggerOnBeforeThemeChange: triggerOnBeforeThemeChange,
    onBeforeThemeChange: onBeforeThemeChange
  }

  return (
    <ThemeContext.Provider value={theme}>
      {props.children}
    </ThemeContext.Provider>
  )
}

Theme.defaultProps = {
  enum: null,
  themes: null,
  defaultTheme: null
}

Theme.propTypes = {
  enum: PropTypes.string,
  themes: PropTypes.array,
  defaultTheme: PropTypes.string
}
